import React from 'react';

import { Button } from '../../../components/common';
import type { ToolId } from '../../layout/workspace-config';
import { useDashboardNavigation } from '../logic/useDashboardNavigation';
import { useDashboardAccessibleToolIds } from '../logic/useDashboardAccessibleToolIds';
import { DashboardWidgetCard } from './DashboardWidgetCard';

interface QuickAction {
    label: string;
    ariaLabel: string;
    icon: string;
    toolId: ToolId;
    search?: string;
}

const QUICK_ACTIONS: QuickAction[] = [
    { label: 'Notes', ariaLabel: 'Open Notes', icon: 'note', toolId: 'notes' },
    { label: 'Attendance', ariaLabel: 'Open Attendance', icon: 'how_to_reg', toolId: 'personnel', search: '?subtab=attendance' },
    { label: 'Feed', ariaLabel: 'Open Feed', icon: 'campaign', toolId: 'feed' },
    { label: 'Line Notes', ariaLabel: 'Open Line Notes', icon: 'edit_note', toolId: 'line-notes' },
];

export const QuickActionsWidget: React.FC = () => {
    const openTool = useDashboardNavigation();
    const accessibleToolIds = useDashboardAccessibleToolIds();
    const visibleActions = QUICK_ACTIONS.filter(action => accessibleToolIds.has(action.toolId));

    return (
        <DashboardWidgetCard title="Quick Actions" icon="bolt" testId="quick-actions-widget">
            <div className="grid grid-cols-2 gap-2">
                {visibleActions.map(action => (
                    <Button
                        key={action.toolId}
                        aria-label={action.ariaLabel}
                        className="justify-start"
                        leftIcon={action.icon}
                        onClick={() => openTool(action.toolId, { search: action.search })}
                        size="sm"
                        variant="secondary"
                    >
                        {action.label}
                    </Button>
                ))}
            </div>
        </DashboardWidgetCard>
    );
};
